import { DynamicFilterFactory } from "components/DynamicFormInput";

import type { RecordFormField } from "./types";

type DynamicFormFieldRendererProps = {
  field: RecordFormField;
};

export const DynamicFormFieldRenderer = ({ field }: DynamicFormFieldRendererProps) => {
  const { filterType, ...args } = field;
  const filterFactory = new DynamicFilterFactory(filterType, args);
  const filterInstance = filterFactory.createFilterClassInstance();

  if (!filterInstance) return null;

  return <div className="w-full min-w-0">{filterInstance.createComponent()}</div>;
};
